import { useEffect } from 'react';

export default function FormActionEnhancer() {
  useEffect(() => {
    const findHeaderHost = (row) => {
      const dialog = row.closest('.p-dialog');
      const scope = dialog || row.closest('.card.app-card') || row.closest('.card');
      if (!scope) return null;

      const isBeforeActions = (candidate) => (
        candidate !== row
        && Boolean(candidate.compareDocumentPosition(row) & Node.DOCUMENT_POSITION_FOLLOWING)
      );
      const header = Array.from(scope.querySelectorAll('.card-header')).find(isBeforeActions)
        || (dialog ? Array.from(scope.querySelectorAll('.p-dialog-header')).find(isBeforeActions) : null);

      if (!header) return null;

      const parent = header.parentElement;
      if (parent && parent.classList.contains('card') && parent.children.length === 1) return parent;
      return header;
    };

    const enhanceActions = () => {
      document.querySelectorAll('.row').forEach((row) => {
        const saveButton = row.querySelector('.btn .pi-check, .btn .pi-save, .p-button:not(.p-togglebutton) .pi-check, .p-button:not(.p-togglebutton) .pi-save');
        const cancelButton = row.querySelector('.btn .pi-times, .p-button:not(.p-togglebutton) .pi-times');

        if (!saveButton || !cancelButton) return;

        const saveButtonElement = saveButton.closest('.btn, .p-button');
        const cancelButtonElement = cancelButton.closest('.btn, .p-button');
        const actionsContainer = saveButtonElement.parentElement;

        if (saveButtonElement.closest('.row') !== row || cancelButtonElement.closest('.row') !== row) return;

        if (actionsContainer) actionsContainer.classList.add('form-action-buttons');
        saveButtonElement.classList.add('form-save-button');
        cancelButtonElement.classList.add('form-cancel-button');
        row.dataset.actionsEnhanced = 'true';

        const headerHost = findHeaderHost(row);
        if (headerHost && actionsContainer) {
          const actionScope = row.closest('.p-dialog') || row.closest('.card.app-card') || row.closest('.card');
          headerHost.classList.add('form-header-bar');
          if (actionScope) actionScope.classList.add('form-with-top-actions');
          actionsContainer.classList.add('form-header-actions');
          row.classList.add('form-action-top-row');
          return;
        }

        row.classList.add('form-action-row');
      });
    };

    enhanceActions();

    const observer = new MutationObserver(enhanceActions);
    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);

  return null;
}




